















































import Vue from 'vue';
import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { POSProductUnpaidForContact } from '@pos/interfaces/pos-v2';

@Component({
  name: 'bpc-pos-contact-details-unpaid-column',
  components: {},
})
export default class PosContactDetailsUnpaidColumn extends Vue {
  // PROPS
  @Prop({ type: String, required: true }) readonly title: string;
  @Prop({ type: Array, required: true }) readonly products: POSProductUnpaidForContact[];
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;

  // DATA

  // COMPUTED

  // LIFECYCLE HOOKS

  // METHODS

  formatDate(value: string) {
    return this.$bpcHelper.formatDate(value);
  }

  formatDateTime(value: string) {
    return this.$bpcHelper.formatDateTime(value);
  }

  clickOnCard(product) {
    this.$emit('add-to-ticket', product);
  }

  formatShortDateTimeRange(startDateTime: string, endDateTime: string) {
    if (!startDateTime) {
      return '';
    }
    const locale = this.lang === 'be' ? 'fr' : this.lang;
    const start = moment(String(startDateTime))
      .locale(locale)
      .format('ddd DD/MM HH:mm');
    if (start) {
      let end = '';
      if (endDateTime) {
        end = moment(String(endDateTime)).format('HH:mm');
      }
      if (end) {
        return start + ' - ' + end;
      } else {
        return start;
      }
    } else {
      return '';
    }
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'];
  }

  // WATCHERS
}
